import { useState } from 'react';

// eslint-disable-next-line import/no-cycle
import LoginModal from 'profile/login/LoginModal';

const NoCustomer = (props) => {
  const { product } = props;
  const [modal, setModal] = useState(null);

  const pricingArray = product.loyalty?.pricing || [];

  const handleLogin = () => {
    setModal('Login');
  };

  return (
    <>
      {pricingArray.length > 0 && (
        <div className="widget-pricing-nocustomer">
          <button type="button" onClick={handleLogin} className="c7-button">
            Member Login
          </button>
          <LoginModal modal={modal} setModal={setModal} />
        </div>
      )}
    </>
  );
};

export default NoCustomer;
